import React from "react";

const about = () => (
  <div>
    <h1>About</h1>
  </div>
);

export default about;
